import React, {Component} from 'react';
import '@assets/sass/components/form/checkbox.scss';

export default class Checkbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: this.props.checked || false,
            name: ''
        };
        this.handleChange = this.handleChange.bind(this);
    }


    componentDidMount() {
        this.setState({
            name: this.props.name
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {checkedAll} = this.props;

        if (prevProps.checkedAll !== checkedAll) {
            if (checkedAll && !this.state.isChecked) {
                this.setState({
                    isChecked: true
                })
            }

            if (!checkedAll && this.state.isChecked) {
                this.setState({
                    isChecked: false
                })
            }
        }
    }

    handleChange(event) {
        const {name} = this.state;

        if (
            (name === 'meta[hotelowa-posciel]') ||
            (name === 'meta[hotelowa-posciel-i-reczniki]')
        ) {
            return
        }

        this.setState({
            isChecked: event.target.checked
        });
        this.props.onChange(this.props.name, event.target.checked);
    }

    renderCheckboxIcon = () => {
        const checkboxName = this.props.name;
        const patternInSquareBrackets = /\[.*]/g;
        const checkboxNameMatched = checkboxName.match(patternInSquareBrackets);
        let checkboxNameExtracted;
        let imageName;

        if (checkboxNameMatched) {
            checkboxNameExtracted = checkboxNameMatched[0].split('');
            checkboxNameExtracted.pop();
            checkboxNameExtracted.shift();
            imageName = checkboxNameExtracted.join('');
        } else if (checkboxName === 'parkingAssigned') {
            imageName = 'special_' + 'parking';
        } else {
            imageName = 'special_' + checkboxName;
        }

        return "/css/img/icons_udogodnienia/udogodnienia_" + imageName + '.svg';
    }

    render() {
        const {label, disabled, className} = this.props;

        return (
            <div className={`
                form-checkbox${className ? ' ' + className : ''}
                ${disabled ? ' disabled' : ''}
                `}>
                <label>
                    <input
                        type="checkbox"
                        onChange={this.handleChange}
                        checked={this.state.isChecked}
                        disabled={disabled}
                    />
                    <span className="form-checkbox__box"/>
                    {this.props.label &&
                    <span className="form-checkbox__label">
                        <img src={this.renderCheckboxIcon()} className="form-checkbox__icon" alt="amenities"/>
                        {(label).charAt(0).toUpperCase() + label.slice(1)}
                    </span>
                    }
                </label>
            </div>
        )
    }
}